import { modals } from "../modals/init-modals";

const citizenRequest = "https://api.migrant-exam.ru/CitizenRequest/NewRequest";
const successModal = "submit-modal";
const errorModal = "submit-modal-error";
const defaultModal = "submit-modal-default";
const spinnerModal = "submit-modal-spinner";

const baseSuccessCallback = (event) => {
  event.preventDefault();
  const formData = Object.fromEntries(new FormData(event.target));
  let status;

  modals.open(spinnerModal);

  fetch(citizenRequest, {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=utf-8" },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      status = response.status;
      return response.json();
    })
    .then((result) => {
      modals.close(spinnerModal);

      if (status == 200) {
        document.querySelector("[data-user-success-link]").href = result.value.message;
        document.querySelector("[data-user-email]").textContent = formData.Email;
        modals.open(successModal);
      } else if (status == 422) {
        if (result.value.errorCode == 2) {
          document.querySelector("[data-user-error-link]").textContent = "Войти в личный кабинет";
        } else {
          document.querySelector("[data-user-error-link]").textContent = "Обратиться в поддержку";
        }
        
        document.querySelector("[data-user-error-link]").href = result.value.linkFeedbackForm;
        document.querySelector("[data-user-message]").textContent = result.value.message;
        modals.open(errorModal);
      } else {
        modals.open(defaultModal);
      }

      try {
        ym(98183557, 'reachGoal', 'submit_form');
      } catch (e) {}

      VK.Goal('lead');
      VK.Retargeting.Event('lead');
      $('#ExamType').val('').trigger('change');
      $('#ExaminationAreaId').val('').trigger('change');
    })
    .catch(function (error) {
      console.log(error);
      modals.close(spinnerModal);
      modals.close("form-modal");
    });
};

const baseErrorCallback = (event) => {
  event.preventDefault();
  // Данный коллбек используется при необходимости выполнить какое-либо действие помимо показа ошибок при попытке отправить неккорректные данные, он не связан с запросами на сервер
};

export const callbacks = {
  base: {
    // Сбросс формы
    reset: true,
    // Таймаут сброса формы
    resetTimeout: 500,
    successCallback: baseSuccessCallback,
    errorCallback: baseErrorCallback,
  },
};
